import Config from "../config/";
export { get, getWithExpiry, remove, set, setWithExpiry } from "./storage";
export const isBrowser = typeof window !== "undefined";

export const getUri = (path: string) => `${Config().shop.url}${path}`;
